import { styled } from '@attentive-platform/stem-ui';

const skipMasked = prop => prop !== 'masked';

export const CompanyFieldLabel = styled('label')({
  display: 'block',
  marginTop: 16,
  marginBottom: 8,
  fontSize: 14,
  fontWeight: 500,
  color: '#111827',
  textAlign: 'left'
});

export const TableSection = styled('div')({
  marginTop: 28
});

export const CredentialsTableEl = styled('table')({
  width: '100%',
  borderCollapse: 'collapse',
  textAlign: 'left',
  fontSize: 14,
  tableLayout: 'fixed'
});

export const PlanroomCol = styled('col')({ width: '18%' });
export const UrlCol = styled('col')({ width: '20%' });
export const UsernameCol = styled('col')({ width: '20%' });
export const PasswordCol = styled('col')({ width: '26%' });
export const ActionsCol = styled('col')({ width: '16%' });

export const PaginationRow = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: 16
});

export const PasswordRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 12
});

export const ActionCluster = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 4
});

export const MaskedValue = styled('span', { shouldForwardProp: skipMasked })(({ masked }) => ({
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  letterSpacing: masked ? '2px' : 0
}));
